import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {FormSectionLoader} from '@/components/commons/form-section/FormSectionLoader'
import {Divider} from '@/components/ui/divider/Divider'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {PageCardWrapper} from '@/components/ui/page-atoms/PageAtoms'

import {PlannedAccessUrlParams} from '@/features/planned-accesses/types'
import {ProjectFormHeadingLoader} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeadingLoader'
import {useGetProject} from '@/features/projects/queries/useGetProject'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {CreatePlannedAccessesFormCard} from '@/features/planned-accesses/components/accesses-form/create-planned-accesses-form-card/CreatePlannedAccessesFormCard'
import {useAccessTypesSearchableList} from '@/features/access-types/hooks/useAccessTypesSearchableList'
import {CreatePlannedAccessesFormProvider} from '@/features/planned-accesses/components/accesses-form/create-planned-accesses-form-provider/CreatePlannedAccessesFormProvider'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const CreatePlannedAccesses = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const urlParams = useURLParsedParams(PlannedAccessUrlParams)

    const {
        data: project,
        isLoading: isLoadingProject,
        isError: isErrorProject
    } = useGetProject({
        urlParams: {projectId: urlParams.success ? urlParams.data.id : ''},
        params: {responseType: 'extended'},
        options: {enabled: urlParams.success}
    })

    const {accessTypes, isLoading: isLoadingAccessTypes} = useAccessTypesSearchableList({
        groupName: 'non_in_person_accesses',
        responseType: 'small',
        limit: 999
    })

    if (!permissions?.accesses.read) {
        return <NoPermissionBox />
    }

    return (
        <>
            <Helmet title={t('planned_accesses:create_meta_title')} />
            {isLoadingProject || isLoadingAccessTypes ? (
                <PageCardWrapper>
                    <ProjectFormHeadingLoader />
                    <Divider direction="horizontal" />
                    <FormSectionLoader />
                </PageCardWrapper>
            ) : isErrorProject ? (
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            ) : (
                <CreatePlannedAccessesFormProvider
                    defaultProjectId={project?.id}
                    defaultAbsenceAccesses={accessTypes}
                    isMixedProject={project?.sector === 'mixed'}
                >
                    <CreatePlannedAccessesFormCard isMissingExpirationDate={!project?.expirationDate} />
                </CreatePlannedAccessesFormProvider>
            )}
        </>
    )
}
